import { render, staticRenderFns } from "./CommercialPolicyAmount.vue?vue&type=template&id=bf0307da&scoped=true&"
import script from "./CommercialPolicyAmount.vue?vue&type=script&lang=js&"
export * from "./CommercialPolicyAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0307da",
  null
  
)

export default component.exports